import React from 'react';
import Select from 'react-select';

import './ForumForm.scss';
import { Loader } from "../../";

class ForumForm extends React.Component {
  constructor() {
    super();

    this.state = {
      surgery: 0,
      procedure: 0,
      doctor: 0,
      name: "",
      email: "",
      title: "",
      text: "",
      error: false
    }
  }

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  };

  renderInput = (name, label, required) => {
    const requiredString = required ? "required" : "";
    return (
      <div className="form-control">
        <label>{label}</label>
        <input
          name={name}
          required={requiredString}
          type="text"
          value={this.state[name]}
          onChange={this.onInputChange}
        />
      </div>
    )
  };

  getDoctorsArray = () => {
    const doctors = this.props.langs.doctors;

    const surgery = this.props.langs.surgery.find(sur => sur.id === this.state.surgery);
    const procedure = surgery.procedures.find(pro => pro.id === this.state.procedure);

    const docs = doctors.map(doc => {
      return {value: doc.id, label: doc.name}
    });

    const filtered =  docs.filter(doc => procedure.doctors.indexOf(doc.value) !== -1);

    return [{value: 31, label: "Klinika Ostrava"},{value: 32, label: "Klinika Olomouc"},{value: 33, label: "Klinika Opava"},...filtered]
  };

  getSurgeriesArray = () => {
    const surgeries = this.props.langs.surgery;

    const surgs = surgeries.map(sur => {
      if (sur.id === 2)
        return {value: sur.id, label: "Laserová a estetická medicína"};
      return {value: sur.id, label: sur.name}
    });

    return [{value: 0, label: "Vyberte sekci..."}, ...surgs];
  };

  getProceduresArray = () => {
    const surgery = this.props.langs.surgery.find(sur => sur.id === this.state.surgery);
    if (!surgery) return [{value: 0, label: "Vyberte sekci..."}];

    const filteredProcs = surgery.procedures.filter(proc => proc.doctors);

    const procedures = filteredProcs.map(proc => {
      return {value: proc.id, label: proc.name};
    });

    return [{value: 0, label: "Vyberte podsekci"}, ...procedures];
  };

  onSurgeryChange = (e) => {
    this.setState({surgery: parseInt(e.value), procedure: 0, error: false, doctor: 0});
  };

  onProcedureChange = (e) => {
    this.setState({procedure: parseInt(e.value), error: false, doctor: 0});
  };

  onDoctorChange = (e) => {
    this.setState({doctor: parseInt(e.value)});
  };

  onSubmit = (e) => {
    e.preventDefault();

    if (this.state.surgery === 0 || this.state.procedure === 0 || this.state.doctor === 0) {
      this.setState({
        error: true
      });
      return;
    }

    const data = this.state;
    // if (data.title.trim() !== "" && data.text.trim() !== "" && data.name.trim() !== "")
    this.props.addThread(data);
  };

  render() {
    return (
      <section className="forumForm">
        <form onSubmit={this.onSubmit}>
          <div className="forumForm_top">
            <div className="container">
              <div className="select-wrapper">
                <label>SEKCE:</label>
                <Select
                  name="surgery"
                  value={this.state.surgery}
                  options={this.getSurgeriesArray()}
                  onChange={this.onSurgeryChange}
                />
              </div>
              <div className="select-wrapper">
                <label>PODSEKCE:</label>
                <Select
                  value={this.state.procedure}
                  options={this.getProceduresArray()}
                  onChange={this.onProcedureChange}
                />
              </div>
              {(this.state.surgery !== 0 && this.state.procedure !== 0) &&
              <div className="select-wrapper">
                <label>NA KOHO DOTAZ JE:</label>
                <Select
                  value={this.state.doctor}
                  options={this.getDoctorsArray()}
                  onChange={this.onDoctorChange}
                />
              </div>
              }
              {this.state.error &&
              <div className="error">
                Vyberte sekci, podsekci a příjemce dotazu
              </div>
              }
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-6">
                {this.renderInput("name", "Jméno", true)}
              </div>
              <div className="col-6">
                {this.renderInput("email", "E-mail")}
              </div>
            </div>
            {this.renderInput("title", "Nadpis dotazu", true)}
            <div className="form-control">
              <label>Váš dotaz</label>
              <textarea

                name="text"
                value={this.state.text}
                onChange={this.onInputChange}
              />
            </div>
            <div className="text-center">
              {this.props.loading ? <Loader/> :
                <button className="btn" type="submit">Odeslat Dotaz</button>
              }
            </div>
          </div>
        </form>
      </section>
    );
  }
}

export default ForumForm;


// WEBPACK FOOTER //
// ./src/components/ForumForm/ForumForm/ForumForm.js